export default "__VITE_ASSET__Bx9H9xkQ__"